import React,{ useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import Header from "./Header";
import { ROUTE_BASE_URL } from "../../api/common";
import Footer from "./Footer";
import { FaTimesCircle } from "react-icons/fa";
// import { convertDBDate } from './common';
// import {
//   GetMemberPaymentInfo
// } from "./Api/services/Webservices";
// import { decryptSlug } from "../../util/encryption"; 

const PaymentFailed = () => {

  // const { slug } = useParams();
  // const decryptedId = decryptSlug(slug);
  // const [userData, setUserData] = useState({});
  // const [userApplicationData, setUserApplicationData] = useState({});
  // const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //   try {
  //     setLoading(true);
  //     GetMemberPaymentInfo({application_no: slug})
  //     .then((res) => {
  //       console.log(res, "UserMemberData");
  //       if (res.status === true && res.data && res.data.length > 0) {
  //         const details = res.data[0];
  //         setUserData(details);
  //       }
  //       if (res.status === true && res.application_data && res.application_data.length > 0) {
  //         const details = res.application_data[0];
  //         setUserApplicationData(details);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });}
  //     catch (error) {
  //       console.error("Error fetching member info:", error);
  //     }
  //     finally {
  //       setLoading(false);
  //     }
  // }, []);
    return (
        <>
            <section className="user_div_total">
               <Header/>
                {/* {!loading && ( */}
                <div className="application_div_page">
                  <div className="application-success">
                    <div className="failed-icon">
                      <FaTimesCircle />
                    </div>
                    <h1>Payment Failed</h1>
                    <div className="summary-box">                    
                      <div className="action-buttons login_details_popup ">
                        <Link to={`${ROUTE_BASE_URL}/user-member-application-list`}>
                          <button className="btn btn-primary ">Back to Home</button>
                        </Link>
                        <a href={`https://www.amasi.org/`}>
                          <button className="btn btn-outline-default">Visit Website</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* )} */}
              <Footer/>
            </section>
        </>
    );

}


export default PaymentFailed
